module.exports = __webpack_public_path__ + "static/media/personal_text_lto.43137000.xlsx";